import type { CellStyle } from 'ag-grid-community';

export const customRendererCellStyle: CellStyle = {
  display: 'flex',
  alignItems: 'center',
};
